import Playground from '../playground.vue';

import PlaygroundHome from '../components/playground-home';

const GridLayoutDemo = () => import('../components/gridlayout-demo.vue');

const DTGridDemo = () => import('../components/dt-grid-demo.vue');

export const PlaygroundRouter = {
  path: '/playground',
  name: 'playground',
  component: Playground,
  redirect: '/playground/plaground_home',
  children: [
    {
      path: 'plaground_home',
      name: 'plaground_home',
      component: PlaygroundHome,
    },
    {
      path: 'grid_demo',
      name: 'grid_demo',
      component: GridLayoutDemo,
    },
    {
      path: 'dt_grid',
      name: 'dt_grid',
      component: DTGridDemo,
    },
  ]
};
